<template>
  <div class="quality-report-dialog">
    <!-- 表单 -->
    <el-dialog :visible="dialogFormVisible" title="学生素质报告书" @open="dialogOpen" @close="dialogClose"
      :close-on-click-modal="false" center width="960px">
      <div class="select-box">
        <div>
          选择学年：
          <el-date-picker style="width: 120px" v-model="ruleForm.schoolYearVal" type="year" value-format="yyyy"
            placeholder="选择学年" :clearable="false">
          </el-date-picker>
        </div>
        <div style="margin: 0 40px 0">
          选择学期：
          <el-select v-model="ruleForm.semesterVal" placeholder="请选择学期" style="width: 120px" clearable>
            <el-option v-for="item in semesterOptions" :key="item.dictValue" :label="item.dictLabel"
              :value="item.dictValue">
            </el-option>
          </el-select>
        </div>
        <div style="margin-right: 30px">
          选择班级：
          <el-cascader v-model="ruleForm.classNameVal" :placeholder="classPlaceholder" :props="classProps"
            :options="classSelect" @change="changeHandle"></el-cascader>
        </div>
        <el-button type="primary" @click="inquire">查 询</el-button>
      </div>
      <table id="studentTable">
        <tbody>
          <!-- 基本信息 -->
          <tr>
            <th :colspan="titleColspan - 1">基本信息</th>
            <td v-if="studentSemesterData.semesterEvaluate" rowspan="4" :style="{
      width: '100px',
      'background-image':
        'url(' + studentSemesterData.semesterEvaluate.qrCode + ')',
      'background-size': 'cover',
      'background-position': 'center',
    }"></td>
            <!-- <td
              v-if="studentSemesterData.semesterEvaluate"
              rowspan="4"
              :style="{
                width: '100px',
                'background-image':
                  'url(http://192.168.1.11:9002/profile/upload/2024/01/04/125c545f-d09b-4e07-800e-6ff8c4581d0d.jpg)',
                'background-size': 'cover',
                'background-position': 'center',
              }"
            ></td> -->
            <td style="width: 100px" v-else rowspan="4"></td>
          </tr>
          <tr>
            <td :colspan="2" class="align-center">姓名</td>
            <td :colspan="2" class="align-center">
              {{ studentSemesterData.studentInfo.studentName }}
            </td>
            <td :colspan="1" class="align-center">班级</td>
            <td :colspan="2" class="align-center">
              {{ studentSemesterData.studentInfo.gradeName
              }}{{ studentSemesterData.studentInfo.className }}
            </td>
          </tr>
          <tr>
            <!-- <td>性别</td>
            <td>{{ studentSemesterData.studentInfo. }}</td> -->
            <td :colspan="2" class="align-center">职务</td>
            <td class="align-center" :colspan="2" contenteditable v-html="jobData.duty" @blur="handleBlurDuty($event)">
            </td>
            <td :colspan="1" class="align-center">政治面貌</td>
            <td class="align-center" contenteditable v-html="jobData.politicsStatus" :colspan="2"
              @blur="handleBlurPoliticsStatus($event)"></td>
          </tr>
          <!-- <tr>
            <td style="width: 80px">学年</td>
            <td :colspan="rateColspan">
              {{
                studentSemesterData.semesterEvaluate
                  ? studentSemesterData.semesterEvaluate.schoolYear
                  : ""
              }}
            </td>
          </tr> -->
          <!-- <tr>
            <td>担任职务</td>
            <td :colspan="jobColspan">{{ studentSemesterData.studentInfo. }}</td>
          </tr> -->
          <!-- 常规课成绩 -->
          <tr>
            <th :colspan="titleColspan - 1">常规课成绩</th>
          </tr>
          <!-- 第一行 -->
          <!-- 科目 -->
          <tr v-if="studentSemesterData.uniqueSubjects.length">
            <td :colspan="disciplineColspan" v-if="studentSemesterData.uniqueSubjects.length" class="align-center">
              学科
            </td>
            <td v-for="item in studentSemesterData.uniqueSubjects.slice(0, 7)" :key="item.courseId"
              :style="{ width: `calc((768px - 120px) / ${7})` }" class="align-center">
              {{ item.courseName }}
            </td>
            <template v-for="index in Math.max(
      7 - studentSemesterData.uniqueSubjects.slice(0, 7).length,
      0
    )">
              <td :style="{ width: `calc((768px - 120px) / ${7})` }"></td>
            </template>
          </tr>
          <!-- 分数 -->
          <tr v-for="(item, index) in studentSemesterData.examInfo" :key="index"
            v-if="studentSemesterData.uniqueSubjects.length">
            <td :colspan="disciplineColspan" style="width: 120px" class="align-center">
              {{ item.subTitle }}
            </td>
            <td v-for="itemC in item.scores.slice(0, 7)" :key="itemC.courseId" class="align-center">
              {{ itemC.evaluate }}
            </td>
            <template v-for="index in Math.max(7 - item.scores.slice(0, 7).length, 0)">
              <td :style="{ width: `calc((768px - 120px) / ${7})` }"></td>
            </template>
          </tr>
          <!-- 第二行 -->
          <!-- 科目 -->
          <tr v-if="studentSemesterData.uniqueSubjects.length > 8">
            <td :colspan="disciplineColspan" class="align-center">学科</td>
            <td v-for="item in studentSemesterData.uniqueSubjects.slice(7, 14)" :key="item.courseId"
              :style="{ width: `calc((768px - 120px) / ${7})` }" class="align-center">
              {{ item.courseName || "" }}
            </td>
            <template v-for="index in Math.max(
      7 - (studentSemesterData.uniqueSubjects.length - 8),
      0
    )">
              <td :style="{ width: `calc((768px - 120px) / ${7})` }"></td>
            </template>
          </tr>
          <!-- 分数 -->
          <tr v-for="(item, index) in studentSemesterData.examInfo" :key="index"
            v-if="studentSemesterData.uniqueSubjects.length > 8">
            <td :colspan="disciplineColspan" style="width: 120px" class="align-center">
              {{ item.subTitle }}
            </td>
            <td v-for="itemC in item.scores.slice(7, 14)" :key="itemC.courseId" class="align-center">
              {{ itemC.evaluate }}
            </td>
            <template v-for="index in Math.max(7 - (item.scores.length - 8), 0)">
              <td :style="{ width: `calc((768px - 120px) / ${7})` }"></td>
            </template>
          </tr>
          <!-- 第三行 -->
          <!-- 科目 -->
          <tr v-if="studentSemesterData.uniqueSubjects.length > 15">
            <td :colspan="disciplineColspan" class="align-center">学科</td>
            <td v-for="item in studentSemesterData.uniqueSubjects.slice(15, 22)" :key="item.courseId"
              :style="{ width: `calc((768px - 120px) / ${7})` }" class="align-center">
              {{ item.courseName || "" }}
            </td>
            <template v-for="index in Math.max(
      7 - (studentSemesterData.uniqueSubjects.length - 15),
      0
    )">
              <td :style="{ width: `calc((768px - 120px) / ${7})` }"></td>
            </template>
          </tr>
          <!-- 分数 -->
          <tr v-if="studentSemesterData.uniqueSubjects.length > 15"
            v-for="(item, index) in studentSemesterData.examInfo" :key="index">
            <td :colspan="disciplineColspan" style="width: 120px" class="align-center">
              {{ item.subTitle }}
            </td>
            <td v-for="itemC in item.scores.slice(15, 22)" :key="itemC.courseId" class="align-center">
              {{ itemC.evaluate }}
            </td>
            <template v-for="index in Math.max(7 - (item.scores.length - 15), 0)">
              <td :style="{ width: `calc((768px - 120px) / ${7})` }"></td>
            </template>
          </tr>
          <!-- <tr>
            <td>总评成绩</td>
            <td v-for="item in achievementList" :key="item.courseName">
              <el-select
                class="rate-select"
                v-model="item.rate"
                :placeholder="disabled ? '无' : '评级'"
                @change="rateSelectChange(item)"
                :disabled="disabled"
              >
                <el-option
                  v-for="item in rateOptions"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                >
                </el-option>
              </el-select>
            </td>
          </tr> -->
          <!-- 实践活动 -->
          <tr>
            <th :colspan="titleColspan">实践活动</th>
          </tr>
          <tr>
            <td :colspan="2" class="align-center">活动名称</td>
            <td :colspan="2" class="align-center">学分</td>
            <td :colspan="2" class="align-center">学时</td>
            <td :colspan="2" class="align-center">评定等级</td>
          </tr>
          <tr v-for="(item, index) in studentSemesterData.practiceRecord" :key="item.activityName">
            <td :colspan="2" class="align-center">
              {{ item.activityName }}
            </td>
            <td :colspan="2" class="align-center">{{ item.credit }}</td>
            <td :colspan="2" class="align-center">{{ item.hours }}</td>
            <td :colspan="2" class="align-center">
              {{ item.evaluationLevel }}
            </td>
          </tr>
          <!-- 选修成绩 -->
          <tr>
            <th :colspan="titleColspan">校本课程选修成绩</th>
          </tr>
          <tr>
            <td :colspan="2" class="align-center">课程名称</td>
            <td :colspan="2" class="align-center">学分</td>
            <td :colspan="2" class="align-center">学时</td>
            <td :colspan="2" class="align-center">评定等级</td>
          </tr>
          <tr v-for="(item, index) in studentSemesterData.electiveGrade" :key="item.courseName">
            <td :colspan="2" class="align-center">
              {{ item.courseName }}
            </td>
            <td :colspan="2" class="align-center">{{ item.credit }}</td>
            <td :colspan="2" class="align-center">{{ item.hours }}</td>
            <td :colspan="2" class="align-center">
              {{ item.evaluationLevel }}
            </td>
          </tr>
          <!-- 获奖情况 -->
          <tr>
            <th :colspan="titleColspan">获奖情况</th>
          </tr>
          <tr>
            <td :colspan="2" class="align-center">日期</td>
            <td :colspan="2" class="align-center">获奖名称</td>
            <td :colspan="2" class="align-center">获奖等级</td>
            <td :colspan="2" class="align-center">颁奖单位</td>
          </tr>
          <tr v-for="item in studentSemesterData.medalInfo" :key="item.id">
            <td :colspan="2" class="align-center">{{ item.gainDate }}</td>
            <td :colspan="2" class="align-center">
              {{ item.competitionName }}
            </td>
            <td :colspan="2" class="align-center">{{ item.medal }}</td>
            <td :colspan="2" class="align-center">
              {{ item.presentationUnit }}
            </td>
          </tr>
          <!-- 考勤情况 -->
          <tr>
            <th :colspan="titleColspan">考勤情况</th>
          </tr>
          <tr>
            <td :colspan="2" class="align-center">旷课(节)</td>
            <td :colspan="1" class="align-center">病假(节)</td>
            <td :colspan="1" class="align-center">事假(节)</td>
            <td :colspan="1" class="align-center">迟到</td>
            <td :colspan="1" class="align-center">早退</td>
            <td :colspan="2" class="align-center">是否全勤</td>
          </tr>
          <tr>
            <td class="align-center" :colspan="2" contenteditable v-html="attendanceStatistics.absenteeism"
              @blur="handleBlurAttendance($event, 'absenteeism')"></td>
            <td class="align-center" :colspan="1" contenteditable v-html="attendanceStatistics.sickLeave"
              @blur="handleBlurAttendance($event, 'sickLeave')"></td>
            <td class="align-center" :colspan="1" contenteditable v-html="attendanceStatistics.personalLeave"
              @blur="handleBlurAttendance($event, 'personalLeave')"></td>
            <td class="align-center" :colspan="1" contenteditable v-html="attendanceStatistics.late"
              @blur="handleBlurAttendance($event, 'late')"></td>
            <td class="align-center" :colspan="1" contenteditable v-html="attendanceStatistics.earlyLeave"
              @blur="handleBlurAttendance($event, 'earlyLeave')"></td>
            <td class="align-center" :colspan="2" contenteditable
              v-html="attendanceStatistics.fullAttendance == '0' ? '否' : '是'"
              @blur="handleBlurAttendance($event, 'fullAttendance')"></td>
          </tr>
          <!-- 班主任评语 -->
          <tr>
            <th :colspan="titleColspan">班主任评语</th>
          </tr>
          <tr>
            <td :colspan="titleColspan" contenteditable v-html="studentSemesterData.semesterEvaluate
        ? studentSemesterData.semesterEvaluate.remark
        : reportData.remark
      " @blur="handleBlurRemark($event)"></td>
          </tr>
          <tr>
            <td :colspan="rateColspan" v-if="studentSemesterData.semesterEvaluate">
              德育考核等级：<el-select class="rate-select" v-model="studentSemesterData.semesterEvaluate.moralismGrade"
                placeholder="请评级" @change="rateSelectChange">
                <el-option v-for="item in rateOptions" :key="item.dictValue" :label="item.dictLabel"
                  :value="item.dictValue">
                </el-option>
              </el-select>
            </td>
            <td :colspan="rateColspan" v-else>
              德育考核等级：
              <el-select class="rate-select" v-model="reportData.moralismGradeVal" placeholder="请评级"
                @change="rateSelectChange">
                <el-option v-for="item in rateOptions" :key="item.dictValue" :label="item.dictLabel"
                  :value="item.dictValue">
                </el-option>
              </el-select>
            </td>
            <td :colspan="1" class="align-center">班主任</td>
            <td class="align-center" :colspan="1" contenteditable v-html="studentSemesterData.semesterEvaluate
        ? studentSemesterData.semesterEvaluate.principal
        : reportData.principal
      " @blur="handleBlurPrincipal($event)"></td>
          </tr>
        </tbody>
      </table>
      <div class="form-btn">
        <el-button type="primary" @click="confirm" v-hasPermi="'sc:semesterdata:edit'">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: [
    "dialogFormVisible",
    "studentSemesterData",
    "titleColspan",
    "contentColspan",
    "jobColspan",
    "rateColspan",
    "rateOptions",
    "schoolInfo",
    "jobData",
    "semesterOptions",
    "classProps",
    "classSelect",
    "classPlaceholder",
    "classData",
    "selectStudent"
  ],
  data() {
    return {
      evaluationGrade: "",
      disciplineColspan: 1,
      reportData: {
        moralismGradeVal: "0", // 德育评级
        principal: "", // 班主任名称
        remark: "", // 评语
      },
      ruleForm: {
        schoolYearVal: "", // 学年
        semesterVal: "", // 学期
        classNameVal: [{ gradeId: "", gradeName: "" }, { classId: "", className: "" }], // 选中的班级
      },
      attendanceStatistics: {
        absenteeism: 0, // 旷课
        sickLeave: 0, // 病假
        personalLeave: 0, // 事假
        late: 0, //迟到
        earlyLeave: 0, // 早退
        fullAttendance: 0, // 是否全勤 0否1是
      }, // 考勤数据
    };
  },
  mounted() {
    this.ruleForm.semesterVal = this.schoolInfo.semester;
    this.ruleForm.schoolYearVal = this.schoolInfo.schoolYear;
    this.ruleForm.classNameVal[1].classId = this.selectStudent.classId;
    this.ruleForm.classNameVal[1].className = this.selectStudent.className;
    this.ruleForm.classNameVal[0].gradeId = this.selectStudent.gradeId;
    this.ruleForm.classNameVal[0].gradeName = this.selectStudent.gradeName;
    // this.ruleForm.classNameVal = this.classData;
    // console.log(this.selectStudent);

    if (!this.studentSemesterData.attendanceStatistics) return;
    this.attendanceStatistics = {
      ...this.attendanceStatistics,
      ...this.studentSemesterData.attendanceStatistics,
    };
  },
  watch: {
    studentSemesterData(newVal, oldVal) {
      if (!newVal.attendanceStatistics)
        return (this.attendanceStatistics = {
          absenteeism: 0, // 旷课
          sickLeave: 0, // 病假
          personalLeave: 0, // 事假
          late: 0, //迟到
          earlyLeave: 0, // 早退
          fullAttendance: 0, // 是否全勤 0否1是
        });
      this.attendanceStatistics = {
        ...this.attendanceStatistics,
        ...newVal.attendanceStatistics,
      };
    },
  },
  methods: {
    // 选择班级
    changeHandle(e) {
      // this.$emit("changeClass", e);
    },
    inquire() {
      this.$emit("inquireClick", this.ruleForm);
    },
    dialogOpen() {
      // this.ruleForm.semesterVal = this.schoolInfo.semester;
      // this.ruleForm.schoolYearVal = this.schoolInfo.schoolYear;
    },
    dialogClose() {
      this.$emit("dialogClose", false);
      // this.$emit("update:dialogFormVisible", false);
    },
    handleBlurPrincipal(event) {
      const plainText = event.target.innerText.replace(/\n/g, "<br/>");
      if (this.studentSemesterData.semesterEvaluate) {
        this.$set(
          this.studentSemesterData.semesterEvaluate,
          "principal",
          plainText
        );
      } else {
        this.$set(this.reportData, "principal", plainText);
      }
    },
    handleBlurRemark(event) {
      const plainText = event.target.innerText.replace(/\n/g, "<br/>");
      if (this.studentSemesterData.semesterEvaluate) {
        this.$set(
          this.studentSemesterData.semesterEvaluate,
          "remark",
          plainText
        );
      } else {
        this.$set(this.reportData, "remark", plainText);
      }
    },
    handleBlurPoliticsStatus(event) {
      const plainText = event.target.innerText.replace(/\n/g, "<br/>");
      this.$set(this.jobData, "politicsStatus", plainText);
    },
    handleBlurDuty(event) {
      const plainText = event.target.innerText.replace(/\n/g, "<br/>");
      this.$set(this.jobData, "duty", plainText);
    },
    handleBlurAttendance(event, name) {
      const plainText = event.target.innerText.replace(/\n/g, "<br/>");
      this.$set(this.attendanceStatistics, name, plainText);
    },
    confirm() {
      // this.studentSemesterData中的semesterEvaluate为NULL时表示没有添加过评定
      if (this.studentSemesterData.semesterEvaluate) {
        // 修改
        this.updateStudentEvaluate();
      } else {
        // 添加
        this.insertStudentEvaluate();
      }
    },
    insertStudentEvaluate() {
      const { schoolId } = this.user;
      const { schoolYearVal, semesterVal } = this.ruleForm;
      const { id: studentId, studentName } =
        this.studentSemesterData.studentInfo;
      const { duty: classJob, politicsStatus } = this.jobData;
      const {
        moralismGradeVal: moralismGrade,
        principal,
        remark,
      } = this.reportData;
      const {
        absenteeism,
        sickLeave,
        personalLeave,
        late,
        earlyLeave,
        fullAttendance,
      } = this.attendanceStatistics;

      const data = {
        schoolId,
        schoolYear: schoolYearVal,
        semester: semesterVal,
        studentId,
        studentName,
        classJob,
        politicsStatus,
        moralismGrade,
        principal,
        remark,
        attendanceStatistics: {
          absenteeism,
          sickLeave,
          personalLeave,
          late,
          earlyLeave,
          fullAttendance,
        },
        classId: this.ruleForm.classNameVal[1].classId,
        gradeId: this.ruleForm.classNameVal[0].gradeId,
      };

      this.post(this.$url.insertStudentEvaluate, data).then((res) => {
        if (res.code !== 200) return this.$message.error(res.msg);
        this.$message.success(res.msg);
        this.dialogClose();
      });
    },
    updateStudentEvaluate() {
      const {
        id: evaluationId,
        moralismGrade,
        principal,
        remark,
      } = this.studentSemesterData.semesterEvaluate;
      const { schoolId } = this.user;
      const { schoolYearVal, semesterVal } = this.ruleForm;
      const { id: studentId, studentName } =
        this.studentSemesterData.studentInfo;
      const { duty: classJob, politicsStatus } = this.jobData;
      const {
        absenteeism,
        sickLeave,
        personalLeave,
        late,
        earlyLeave,
        fullAttendance,
      } = this.attendanceStatistics;

      const data = {
        id: evaluationId,
        schoolId,
        schoolYear: schoolYearVal,
        semester: semesterVal,
        studentId,
        studentName,
        classJob,
        politicsStatus,
        moralismGrade,
        principal,
        remark,
        attendanceStatistics: {
          absenteeism,
          sickLeave,
          personalLeave,
          late,
          earlyLeave,
          fullAttendance,
        },
        classId: this.ruleForm.classNameVal[1].classId,
        gradeId: this.ruleForm.classNameVal[0].gradeId,
      };
      // console.log("修改的参数==>", data);

      this.put(this.$url.updateStudentEvaluate, data).then((res) => {
        if (res.code !== 200) return this.$message.error(res.msg);
        this.$message.success(res.msg);
        this.dialogClose();
      });
    },
    rateSelectChange(e) {
      // let { evaluationGrade, courseId } = e;
      // let { studentId, id: examInfoId } = this.studentInfo;
      // let data = {
      //   examInfoId: +examInfoId,
      //   studentId: +studentId,
      //   courseId,
      //   evaluationGrade: +evaluationGrade,
      // };
      // if (!e.isRated) {
      //   this.post(this.$url.addEvaluation, data).then((res) => {
      //     if (res.code != 200) return this.$message.error(res.msg);
      //     e.isRated = true;
      //     this.$message.success(res.msg);
      //   });
      // } else {
      //   this.put(this.$url.editEvaluation, data).then((res) => {
      //     if (res.code != 200) return this.$message.error(res.msg);
      //     this.$message.success(res.msg);
      //   });
      // }
    },
  },
};
</script>

<style scoped lang="scss">
@import "./quality-report-dialog.scss";
</style>
